import { HttpAuth, HttpUpload } from '../../config/Http'
import { changeLoading } from './loading.action'
import { changeScreen } from './navigation.action'
import { changeNotify } from './notify.action'
import { changeAlert } from './alert.action'

export const actionTypes = {
    INDEX: 'CAMPAIGNS_INDEX',
    CHART: 'CAMPAIGNS_CHART',
    STORE: 'CAMPAIGNS_STORE',
    UPDATE: 'CAMPAIGNS_UPDATE',
    LOADING: 'CAMPAIGNS_LOADING',
    DESTROY: 'CAMPAIGNS_DESTROY',
    UPLOAD: 'CAMPAIGNS_UPLOAD_PHOTO',
    COUNT: 'CAMPAIGNS_COUNT',
    DELETE_PHOTO: 'CAMPAIGNS_DELETE_PHOTO',
    REORDER_PHOTO: 'CAMPAIGNS_REORDER_PHOTO',
    CHANGE: 'CAMPAIGNS_CHANGE',
    SUCCESS: 'CAMPAIGNS_SUCCESS',
    ERROR: 'CAMPAIGNS_ERROR'
}

export const change = (payload) => ({
    type: actionTypes.CHANGE,
    payload
})

export const success = (payload) => ({
    type: actionTypes.SUCCESS,
    payload
})

export const error = (payload) => ({
    type: actionTypes.ERROR,
    payload
})

export const loadingResponse = (payload) => ({
    type: actionTypes.LOADING,
    payload
})

// COUNT

export const countResponse = (payload, campaign_id) => ({
    type: actionTypes.COUNT,
    payload,
    campaign_id
})

export const count = (campaign_id, loading = true) => dispatch => {
    if(loading) {
        dispatch(changeLoading({ open: true }))
    }
    
    return HttpAuth.post('/campaigns/count/'+campaign_id)
            .then(res => {
                if(typeof res !== 'undefined') {
                    dispatch(countResponse(res.data, campaign_id))
                    if(!res.data.loading && !loading) {
                        dispatch(loadingResponse(res.data.campaign))
                    }
                }
                dispatch(changeLoading({ open: false }))
            })
            .catch(error => {
                dispatch( changeLoading({ open: false }) );
        
                if(typeof error.response !== 'undefined') {
                    if(error.response.status === 400) {
                        if(typeof error.response.data === 'object'){
                            
                            if(typeof error.response.data.error !== undefined) {
                                if(typeof error.response.data.error === 'string'){
                                    dispatch( changeNotify({
                                        open: true,
                                        class: 'error',
                                        msg: error.response.data.error
                                    }))
                                }
                            }
    
                            if(typeof error.response.data.class !== undefined) {
                                dispatch(changeNotify({
                                    open: true,
                                    msg: error.response.data.msg,
                                    class: error.response.data.class
                                }))
                                dispatch(success(true))
                            }
                        }
                    }
                }
            })
}

export const total = (campaign_id, loading = true) => dispatch => {
    if(loading) {
        dispatch(changeLoading({ open: true }))
    }
    
    return HttpAuth.post('/campaigns/total/'+campaign_id)
            .then(res => {
                if(typeof res !== 'undefined') {
                    dispatch(countResponse(res.data, campaign_id))
                    if(!res.data.loading && !loading) {
                        dispatch(loadingResponse(res.data.campaign))
                    }
                }
                dispatch(changeLoading({ open: false }))
            })
}


// INDEX

export const indexResponse = (payload, isLoadMore) => ({
    type: actionTypes.INDEX,
    payload,
    isLoadMore
})

export const index = (query, isLoadMore) => dispatch => {
    return HttpAuth.get('/campaigns?'+ new URLSearchParams(query))
            .then(res =>  {
                if(typeof res !== 'undefined') {
                    dispatch(indexResponse(res.data, isLoadMore))
                }
            })
}

// ENCERRADAS

export const closedResponse = (payload, isLoadMore) => ({
    type: actionTypes.INDEX,
    payload,
    isLoadMore
})

export const closed = (query, isLoadMore) => dispatch => {
    return HttpAuth.get('/campaigns/closed?'+ new URLSearchParams(query))
            .then(res => typeof res !== 'undefined' && dispatch(closedResponse(res.data, isLoadMore)))
}

// LIXEIRA

export const trashResponse = (payload, isLoadMore) => ({
    type: actionTypes.INDEX,
    payload,
    isLoadMore
})

export const trash = (query, isLoadMore) => dispatch => {
    return HttpAuth.get('/campaigns/trash?'+ new URLSearchParams(query))
            .then(res => typeof res !== 'undefined' && dispatch(closedResponse(res.data, isLoadMore)))
}

// CHART 
export const chartResponse = (payload) => ({
    type: actionTypes.CHART,
    payload
})

export const chartGeneralPeriod = (query) => dispatch => {
    return HttpAuth.post('/campaigns/chart/general/period?'+ new URLSearchParams(query))
        .then(res => typeof res !== 'undefined' && dispatch(chartResponse({period: res.data})))
}

export const chartGeneralHourly = (query) => dispatch => {
    return HttpAuth.post('/campaigns/chart/general/hourly?'+ new URLSearchParams(query))
        .then(res => typeof res !== 'undefined' && dispatch(chartResponse({hour: res.data})))
}


export const chartPeriod = (query) => dispatch => {
    return HttpAuth.post('/campaigns/chart/period?'+ new URLSearchParams(query))
        .then(res => typeof res !== 'undefined' && dispatch(chartResponse({campaign: res.data?.campaign, period: res.data})))
}

export const chartHourly = (query) => dispatch => {
    return HttpAuth.post('/campaigns/chart/hourly?'+ new URLSearchParams(query))
        .then(res => typeof res !== 'undefined' && dispatch(chartResponse({campaign: res.data?.campaign, hour: res.data})))
}

// RESTAURAR

export const restore = (id) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.post('/campaigns/restore/'+ id)
        .then(res => {
            dispatch(changeLoading({ open: false }))
            if(typeof res !== 'undefined') {
                dispatch(changeNotify({
                    open: true,
                    msg: res.data.msg,
                    class: 'success'
                }))
                
                dispatch(destroyResponse(id))
            }
        })
        .catch(error => {
            dispatch( changeLoading({ open: false }) );
    
            if(typeof error.response !== 'undefined') {
                if(error.response.status === 400) {
                    if(typeof error.response.data === 'object'){
                        
                        if(typeof error.response.data.error !== undefined) {
                            if(typeof error.response.data.error === 'string'){
                                dispatch( changeNotify({
                                    open: true,
                                    class: 'error',
                                    msg: error.response.data.error
                                }))
                            }
                        }

                        if(typeof error.response.data.class !== undefined) {
                            dispatch(changeNotify({
                                open: true,
                                msg: error.response.data.msg,
                                class: error.response.data.class
                            }))
                            dispatch(success(true))
                        }
                    }
                }
            }
        })
}

// STORE

export const store = (data) => dispatch => {
    return HttpAuth.post('/campaigns', data)
        .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data)))
        .catch(erro => {
            dispatch(changeLoading({ open: false }))
            dispatch(changeScreen({ open: false }))
            if(erro.response) {
                if(erro.response.data.msg) {
                    dispatch(changeAlert({
                        open: true,
                        msg: erro.response.data.msg,
                        class: 'error'
                    }))
                }
                if(erro.response.data.error) {
                    dispatch(error(erro.response.data.error))
                }
            }
        })
}

// SHOW

export const show = (id) => dispatch => {
    return HttpAuth.get('/campaigns/'+ id)
        .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data)))
        .catch(erro => {
            if(erro.response) {
                dispatch(changeNotify({
                    open: true,
                    msg: erro.response.data.msg,
                    class: erro.response.data.class
                }))
                dispatch(success(true))
            }
        })
}

// SORTEAR

export const first = (data) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.put('/campaigns/raffle/first/'+ data.id, data)
        .then(res => {
            if(res.data.ganhador) {
                dispatch(show(data.id)).then(() => {
                    dispatch(changeLoading({ open: false }))
                    dispatch(changeNotify({
                        open: true,
                        msg: res.data.msg,
                        class: res.data.class
                    }))
                })
                dispatch(index({page: 1}, false))
            }
        })
        .catch(erro => {
            dispatch(changeLoading({ open: false }))

            if(erro.response) {
                if(erro.response.data.msg) {
                    dispatch(changeAlert({
                        open: true,
                        msg: erro.response.data.msg,
                        class: erro.response.data.class
                    }))
                }
                if(erro.response.data.error) {
                    dispatch(error(erro.response.data.error))
                }
            }
        })
}

export const second = (data) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.put('/campaigns/raffle/second/'+ data.id, data)
        .then(res => {
            dispatch(changeLoading({ open: false }))

            if(res.data.ganhador2) {
                dispatch(show(data.id))
                dispatch(index({page: 1}, false))
            }
            dispatch(changeNotify({
                open: true,
                msg: res.data.msg,
                class: res.data.class
            }))
        })
        .catch(erro => {
            dispatch(changeLoading({ open: false }))

            if(erro.response) {
                if(erro.response.data.msg) {
                    dispatch(changeAlert({
                        open: true,
                        msg: erro.response.data.msg,
                        class: erro.response.data.class
                    }))
                }
                if(erro.response.data.error) {
                    dispatch(error(erro.response.data.error))
                }
            }
        })
}

export const third = (data) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.put('/campaigns/raffle/third/'+ data.id, data)
        .then(res => {
            dispatch(changeLoading({ open: false }))

            if(res.data.ganhador3) {
                dispatch(show(data.id))
                dispatch(index({page: 1}, false))
            }
            dispatch(changeNotify({
                open: true,
                msg: res.data.msg,
                class: res.data.class
            }))
        })
        .catch(erro => {
            dispatch(changeLoading({ open: false }))

            if(erro.response) {
                if(erro.response.data.msg) {
                    dispatch(changeAlert({
                        open: true,
                        msg: erro.response.data.msg,
                        class: erro.response.data.class
                    }))
                }
                if(erro.response.data.error) {
                    dispatch(error(erro.response.data.error))
                }
            }
        })
}

export const fourth = (data) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.put('/campaigns/raffle/fourth/'+ data.id, data)
        .then(res => {
            dispatch(changeLoading({ open: false }))

            if(res.data.ganhador4) {
                dispatch(show(data.id))
                dispatch(index({page: 1}, false))
            }
            dispatch(changeNotify({
                open: true,
                msg: res.data.msg,
                class: res.data.class
            }))
        })
        .catch(erro => {
            dispatch(changeLoading({ open: false }))

            if(erro.response) {
                if(erro.response.data.msg) {
                    dispatch(changeAlert({
                        open: true,
                        msg: erro.response.data.msg,
                        class: erro.response.data.class
                    }))
                }
                if(erro.response.data.error) {
                    dispatch(error(erro.response.data.error))
                }
            }
        })
}

export const fifth = (data) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.put('/campaigns/raffle/fifth/'+ data.id, data)
        .then(res => {
            dispatch(changeLoading({ open: false }))

            if(res.data.ganhador5) {
                dispatch(show(data.id))
                dispatch(index({page: 1}, false))
            }
            dispatch(changeNotify({
                open: true,
                msg: res.data.msg,
                class: res.data.class
            }))
        })
        .catch(erro => {
            dispatch(changeLoading({ open: false }))
            
            if(erro.response) {
                if(erro.response.data.msg) {
                    dispatch(changeAlert({
                        open: true,
                        msg: erro.response.data.msg,
                        class: erro.response.data.class
                    }))
                }
                if(erro.response.data.error) {
                    dispatch(error(erro.response.data.error))
                }
            }
        })
}

export const plus = (data) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.put('/campaigns/raffle/plus/'+ data.id, data)
        .then(res => {
            dispatch(changeLoading({ open: false }))

            if(res.data.ganhador_mais) {
                dispatch(show(data.id))
                dispatch(index({page: 1}, false))
            }
            dispatch(changeNotify({
                open: true,
                msg: res.data.msg,
                class: res.data.class
            }))
        })
        .catch(erro => {
            dispatch(changeLoading({ open: false }))
            
            if(erro.response) {
                if(erro.response.data.msg) {
                    dispatch(changeAlert({
                        open: true,
                        msg: erro.response.data.msg,
                        class: erro.response.data.class
                    }))
                }
                if(erro.response.data.error) {
                    dispatch(error(erro.response.data.error))
                }
            }
        })
}

// UPDATE

export const updateResponse = (payload) => ({
    type: actionTypes.UPDATE,
    payload
})

export const update = (data) => dispatch => {
    dispatch(changeLoading({ open: true }))
	

    return HttpAuth.put('/campaigns/'+data.id, data)
        .then(res => {
            if(typeof res !== 'undefined') {
                if(res.data.success === 200) {
                    dispatch(index({page: 1}, false)).then(res => {
                        dispatch(changeLoading({ open: false }))
                    })
                    dispatch(success(true))
                    dispatch(changeNotify({
                        open: true,
                        msg: res.data.msg,
                        class: 'success'
                    }))
                    dispatch(changeScreen({ open: false }))
                } else {
                    dispatch(changeLoading({
                        open: false,
                        msg: 'Carregando...'
                    }))
                }
            }
        })
        .catch(erro => {
            if(erro.response) {
                if(erro.response.data.error) {
                    dispatch(error(erro.response.data.error))
                    let res = erro.response.data.error[Object.keys(erro.response.data.error)[0]]
                    if(res[0]) {
                        dispatch(changeAlert({
                            open: true,
                            msg: res[0],
                            class: 'error'
                        }))
                    }
                }
            }
            dispatch(changeLoading({ 
				open: false,
				msg: 'Carregando...'
			}))

            return 'error';
        })
}


// RESET

export const reset = (id) => dispatch => {
    dispatch(changeLoading({ open: true }))
	

    return HttpAuth.put('/campaigns/reset/'+ id)
        .then(res => {
            dispatch(changeLoading({ open: false }))
            if(typeof res !== 'undefined') {
                if(res.data.success === 200) {
                    dispatch(success(true))
                    dispatch(changeNotify({
                        open: true,
                        msg: res.data.msg,
                        class: 'success'
                    }))
					dispatch(destroyResponse(id))
                    dispatch(changeScreen({ open: false }))
                }
            }
        })
        .catch(error => {
            dispatch( changeLoading({ open: false }) );
    
            if(typeof error.response !== 'undefined') {
                if(error.response.status === 400) {
                    if(typeof error.response.data === 'object'){
                        
                        if(typeof error.response.data.error !== undefined) {
                            if(typeof error.response.data.error === 'string'){
                                dispatch( changeNotify({
                                    open: true,
                                    class: 'error',
                                    msg: error.response.data.error
                                }))
                            }
                        }

                        if(typeof error.response.data.class !== undefined) {
                            dispatch(changeNotify({
                                open: true,
                                msg: error.response.data.msg,
                                class: error.response.data.class
                            }))
                            dispatch(success(true))
                        }
                    }
                }
            }
        })
}


// DESTROY

export const destroyResponse = (payload) => ({
    type: actionTypes.DESTROY,
    payload
})

export const destroy = (id) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.delete('/campaigns/'+ id)
        .then(res => {
            dispatch(changeLoading({ open: false }))
            if(typeof res !== 'undefined') {
                dispatch(changeNotify({
                    open: true,
                    msg: res.data.msg,
                    class: 'success'
                }))
                
                dispatch(destroyResponse(id))
            }
        })
        .catch(error => {
            dispatch( changeLoading({ open: false }) );
    
            if(typeof error.response !== 'undefined') {
                if(error.response.status === 400) {
                    if(typeof error.response.data === 'object'){
                        
                        if(typeof error.response.data.error !== undefined) {
                            if(typeof error.response.data.error === 'string'){
                                dispatch( changeNotify({
                                    open: true,
                                    class: 'error',
                                    msg: error.response.data.error
                                }))
                            }
                        }

                        if(typeof error.response.data.class !== undefined) {
                            dispatch(changeNotify({
                                open: true,
                                msg: error.response.data.msg,
                                class: error.response.data.class
                            }))
                            dispatch(success(true))
                        }
                    }
                }
            }
        })
}

// UPLOAD PHOTO

export const uploadPhotoResponse = (payload) => ({
    type: actionTypes.UPLOAD,
    payload
})

export const uploadPhoto = (item) => dispatch => {
    dispatch(change({ upload_photo: true }))

    return HttpUpload.post('upload/rifa', item)
        .then(res => {
            dispatch(change({ upload_photo: false }))

            if(typeof res !== 'undefined') {
                if(res.data.id) {
                    dispatch(uploadPhotoResponse(res.data));
                }
            }
        })
}

// DELETE PHOTO

export const deletePhotoResponse = (payload) => ({
    type: actionTypes.DELETE_PHOTO,
    payload
})

export const deletePhoto = (id) => dispatch => {
    return HttpAuth.delete('upload/rifa/'+id)
        .then(res => {
            if(typeof res !== 'undefined') {
                if(res.data.error) {
                    dispatch(changeNotify({
                        open: true,
                        msg: res.data.error,
                        class: 'error'
                    }))
                }
                
                if(res.data.success) {
                    dispatch(deletePhotoResponse(id));
                }
            }
        })
}

// REORDER PHOTO

export const reorderPhotoResponse = (payload) => ({
    type: actionTypes.REORDER_PHOTO,
    payload
})

export const reorderPhoto = (pos , data) => dispatch => {
    dispatch(reorderPhotoResponse(data));

    return HttpAuth.put('upload/rifa/position', pos)
        .then(res => {
            if(typeof res !== 'undefined') {
                if(res.data.success) {
                    dispatch(changeNotify({
                        open: true,
                        msg: res.data.success,
                        class: 'success'
                    }))
                }
            }
        })
}

// REPORTS

export const reports = (filter, id, type = 'private') => dispatch => {
    let host = '/campaigns/reports/'

    if(type === 'public') {
        host = '/campaigns/reports/public/'
    }

    if(type === 'users') {
        host = '/campaigns/reports/users/'
    }

    dispatch(changeLoading({ 
        open: true,
        msg: 'Gerando relatório...'
    }))
    return HttpAuth.post(host+id, filter)
        .then((res) => {
            if (res.status !== 200) throw new Error('Erro na resposta');

            dispatch(changeLoading({ 
                open: false,
                msg: 'Carregando...'
            }))
            
            if(res.status === 200) {
                const form = document.createElement('form');
                const secureUrl = res.data.url.replace('http:', 'https:');
                const urlObj = new URL(secureUrl)
                form.action = urlObj.origin + urlObj.pathname;
                form.method = 'GET';

                form.style.display = 'none';

                urlObj.searchParams.forEach((value, key) => {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = key;
                    input.value = value;
                    form.appendChild(input);
                });
                
                document.body.appendChild(form);
                form.submit();
            }
        })
        .catch((error) => {
            dispatch(changeLoading({ 
                open: false,
                msg: 'Carregando...'
            }))
            
            dispatch(changeNotify({
                open: true,
                msg: 'Erro ao baixar o relatório.',
                class: 'error'
            }))
        });
}